import { SET_IS_STATIC } from 'actions';

export const setIsStatic = (isStatic: boolean) => {
  return { isStatic, type: SET_IS_STATIC };
};
